/* eslint-disable react/no-find-dom-node */
import React, { Component, Fragment, ReactInstance } from 'react';
import { findDOMNode } from 'react-dom';

import LayoutConstraintContent from './LayoutConstraintContent';

interface Props {
	children: ((params: { referenceRect: DOMRect }) => React.ReactNode) | React.ReactNode;
	reference: React.ReactElement;
}

export default class LayoutConstraint extends Component<Props> {
	static defaultProps = {
		children: null,
	};

	referenceElement: ReactInstance | null = null;

	render() {
		const { children, reference } = this.props;

		return (
			<Fragment>
				{React.cloneElement(reference, {
					ref: (ref: ReactInstance) => (this.referenceElement = ref),
				})}
				{children !== null ? (
					<LayoutConstraintContent resolveReference={() => findDOMNode(this.referenceElement)}>
						{children}
					</LayoutConstraintContent>
				) : null}
			</Fragment>
		);
	}
}
